import context from '../serverContext';
import { heapTrackEvent } from '@shared_modules/baui-heap-tracking';
import { LOAN_TYPES, HEAP_TRACK } from '@shared_modules/baui-utils/client/constants';
import { getBtMktLoanPurposeXpStr } from '@shared_modules/baui-utils/client/utils';
import { loanAmountFlatValidation } from '@shared_modules/hooks/AmountPurpose/utils';

/**
 * Truncates the name and appends ellipsis if the name is:
 * - longer than 15 characters in mobile
 * - longer than 30 characters in desktop
 *
 * @param {String} name
 */
const truncateLongName = name => {
  const maxLength = window.innerWidth <= 767 ? 15 : 30;
  if (name && name.length > maxLength) {
    return `${name.substring(0, maxLength)}...`;
  }
  return name;
};

const getTrackingAttributes = loanType => {
  const { isFromSecondLoanFlow, lockedPI1Context, dm = {} } = context;
  return {
    APP_REQUEST_TYPE: loanType,
    APP_TYPE: loanType,
    FUNNEL: dm.isDm ? 'DM' : 'Main',
    IS_SECOND_LOAN: isFromSecondLoanFlow,
    IS_LOAN_APP_IN_PROGRESS: lockedPI1Context.inProgress,
    IS_MISSING_DM_PII: dm.hasPartialDMPII,
    IS_ITA: dm.leadType === 'ITA',
  };
};

const getBtMktLoanPurposeTrackingAttrs = (opts = {}) => {
  const { prequal, repeatsContext } = context;
  const dataContext = prequal || repeatsContext?.dataContext?.primaryBorrower || {};
  return {
    MKT_EXPERIMENT: getBtMktLoanPurposeXpStr(dataContext.experiment),
    MKT_LOAN_PURPOSE: dataContext.mktLoanPurpose,
    ...(opts.withLoanAmount ? { LOAN_AMOUNT: dataContext.loanAmount } : {}),
    ...(opts.withType ? { TYPE_BY_MKT_PURPOSE: dataContext.btVariant } : {}),
    ...(opts.appendAttrs || {}),
  };
};

// track user attempt to submit
const submitHeapTracking = (isJoint, extraProps, customProps) =>
  heapTrackEvent(
    HEAP_TRACK.EVENT_NAMES.PL_APPLICATION_FRONTEND,
    customProps || {
      ...getTrackingAttributes(isJoint ? LOAN_TYPES.JOINT : LOAN_TYPES.INDIVIDUAL),
      ...extraProps,
    }
  );

const trackAppStart = (attributes = {}) => {
  const pathname = window.location.pathname.split('/');
  heapTrackEvent('Originations_PL_App_Start_Main_DM', {
    FUNNEL_TYPE: attributes.isDm ? 'DM' : 'Main',
    PAGE_SHOWN: pathname.pop(),
    BORROWER_TYPE: 'NEW',
    PRODUCT_TYPE: 'PL',
    '1QAAT_FLOW': true,
    ...getBtMktLoanPurposeTrackingAttrs({ withLoanAmount: true }),
  });
};

const appendQueryStrToNextPage = (data = {}) => {
  const { nextPage } = data;
  let nextRoute;
  if (nextPage.includes('get-auto-loan')) {
    const { plDecline2Auto, loanId } = data;
    nextRoute = `${nextPage}?${queryString({ ...plDecline2Auto, loanId })}`;
  } else {
    nextRoute = nextPage;
  }

  return nextRoute;
};

const queryString = obj =>
  Object.keys(obj)
    .map(key => key + '=' + obj[key])
    .join('&');

const removeFromArray = (arr = [], targetItem) => {
  const index = arr.findIndex(arrItem => arrItem === targetItem);
  if (index > -1) arr.splice(index, 1);
  return arr;
};

const filterArrayItems = (arr = [], targetItems = [], exclude = true) =>
  arr.filter(item => (exclude ? !targetItems.includes(item) : targetItems.includes(item)));

/**
 * Add additional item to existing array at the index of the specifed item (beforeItem)
 * @param {array} arr
 * @param {string} beforeItem
 * @param {string} newItem
 */
const insertArrayItem = (arr, beforeItem, newItem) => {
  const beforeStepIndex = arr.findIndex(item => item === beforeItem);
  arr.splice(beforeStepIndex + 1, 0, newItem);
  return arr;
};

const hasMatchingArrayElements = (arr1, arr2) => {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    return false;
  }

  return arr1.some(value => arr2.includes(value));
};

const isValidLoanAmount = loanAmount => {
  const loanAmountErrors = loanAmountFlatValidation(loanAmount);
  return Object.keys(loanAmountErrors).length === 0;
};

export {
  appendQueryStrToNextPage,
  filterArrayItems,
  getBtMktLoanPurposeTrackingAttrs,
  getTrackingAttributes,
  hasMatchingArrayElements,
  insertArrayItem,
  isValidLoanAmount,
  removeFromArray,
  submitHeapTracking,
  trackAppStart,
  truncateLongName,
};

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pi1-1QAAT.scss');